import { Grid, Link, Typography } from "@mui/material";

import map_imageUrl from "@/assets/images/FAQ/map.png";
import map_thumbnailUrl from "@/assets/images/FAQ/map_thumbnail.png";
import { faqContacts } from "@/utils/staticData/contacts";
import { FONT_PRIMARY } from "@/theme/typography";

import AnimatedImage from "@/components/UI-Kit/AnimatedImage";
import Section from "@/components/Section";

const FAQMap = () => {
  return (
    <Section pt={0} pb={{ md: 14, lg: 25 }}>
      {/* Map */}
      <AnimatedImage
        sx={{
          width: "100%",
          mb: 8,
          img: { width: "100%", height: "auto", objectFit: "contain" },
        }}
        thumbnailUrl={map_thumbnailUrl}
        mainUrl={map_imageUrl}
        alt="solutions-map"
      />

      {/* Contacts */}
      <Grid container spacing={2} maxWidth={1280} mx="auto">
        {faqContacts.map(({ title, subtitle, label, value, type }, index) => (
          <Grid key={index} item xs={4} textAlign="center">
            <Typography variant="h4" mb={0.5} color="text.primary">
              {title}
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              mb={1}
              color="text.secondary"
            >
              {subtitle}
            </Typography>
            <Link
              href={
                type === "email"
                  ? `mailto:${value}`
                  : type === "phone"
                  ? `tel:${value}`
                  : `${value}`
              }
              underline="hover"
              color="primary.main"
              sx={{ display: "block", py: { xs: 0.5, lg: 1.5 } }}
            >
              <Typography
                variant="subtitle1"
                component="span"
                color="inherit"
                fontWeight={600}
                fontFamily={FONT_PRIMARY}
              >
                {label}
              </Typography>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default FAQMap;
